import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Utils } from 'src/app/pages/auth/utils/Utils';
import { formErrorHelper } from 'src/app/utils/errorCodes';

interface IDataDeposit {
  depositAddress: string;
  depositAmount: string;
  withdrawCost: string;
  side: 'BUY' | 'SELL';
  asset: string;
  price: string;
  withdrawAmount: string;
  against: string;
  availableDepositNetworks: string[];
  depositAlias?: string;
}

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrl: './deposit.component.scss',
})
export class DepositComponent {
  @Input() dataDeposit: IDataDeposit;
  @Input() isSixalime;
  asset: string = '';
  bankControl = new FormControl(null, [Validators.required]);
  banks: { value: string; name: string }[] = [
    { value: 'BBVA', name: 'BBVA' },
    { value: 'MERCADO_PAGO', name: 'Mercado pago' },
    { value: 'GALICIA', name: 'Galicia' },
    { value: 'SANTANDER', name: 'Santander' },
    { value: 'MACRO', name: 'Macro' },
    { value: 'NACION', name: 'Banco nación' },
    { value: 'HSBC', name: 'HSBC' },
    { value: 'SUPERVIELLE', name: 'SUPERVIELLE' },
    { value: 'OTHER_BANK', name: 'Otro banco' },
  ];
  dataLinksBank = {
    MERCADO_PAGO: {
      android: 'https://play.google.com/store/apps/details?id=com.mercadopago.wallet',
      ios: 'https://apps.apple.com/ar/app/mercado-pago-cuenta-digital/id925436649',
    },
    BBVA: {
      android: 'https://play.google.com/store/apps/details?id=com.bbva.nxt_argentina',
      ios: 'https://apps.apple.com/ar/app/bbva-argentina/id748231035',
    },
    GALICIA: {
      android: 'https://play.google.com/store/apps/details?id=com.mosync.app_Banco_Galicia',
      ios: 'https://apps.apple.com/ar/app/galicia-el-banco-en-tu-celu/id774860115',
    },
    SANTANDER: {
      android: 'https://play.google.com/store/apps/details?id=ar.com.santander.rio.mbanking',
      ios: 'https://apps.apple.com/ar/app/santander-argentina/id626971464',
    },
    MACRO: {
      android: 'https://play.google.com/store/apps/details?id=ar.macro',
      ios: 'https://apps.apple.com/ar/app/macro/id1173611617',
    },
    NACION: {
      android: 'https://play.google.com/store/apps/details?id=com.banconacion.bnamas',
      ios: 'https://apps.apple.com/ar/app/bna/id1523383806',
    },
    HSBC: {
      android: 'https://play.google.com/store/apps/details?id=ar.com.hsbc.hsbcargentina',
      ios: 'https://apps.apple.com/ar/app/hsbc-argentina/id1531853717',
    },
    SUPERVIELLE: {
      android: 'https://play.google.com/store/apps/details?id=com.supervielle',
      ios: 'https://apps.apple.com/ar/app/supervielle/id1547826699',
    },
  };
  errorHelper: formErrorHelper;
  isDesktop: boolean;
  isCopiedCbu: boolean;
  isCopiedAlias: boolean;
  isCopiedAmount: boolean;

  constructor() {
    this.errorHelper = new formErrorHelper();
    this.isDesktop = Utils.onDesktop();
  }

  copyToClipboard(value: string, cbu: boolean, alias?: boolean, amount?: boolean) {
    this.isCopiedCbu = cbu;
    this.isCopiedAlias = alias;
    this.isCopiedAmount = amount;
    window.navigator.clipboard.writeText(value);
    setTimeout(() => {
      this.isCopiedCbu = false;
      this.isCopiedAlias = false;
      this.isCopiedAmount = false;
    }, 1050);
  }
  openBankApp() {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    let appUrl = this.dataLinksBank[this.bankControl.value].android;
    if (isIOS) {
      appUrl = `${this.dataLinksBank[this.bankControl.value].ios}`;
    }

    window.location.href = appUrl;
  }
}
